import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import SweetAlert from "react-bootstrap-sweetalert";
import Box from "@mui/material/Box";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import axios from "axios";
import Pagination from "../../Pagination/Pagination";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";
import { useAppContext } from "../../Lib/ContextLib";
import html2pdf from "html2pdf.js";
// import ReactHTMLTableToExcel from "react-html-table-to-excel";
import moment from "moment";
import { useLocation } from "react-router-dom";

export default function Reward() {
  

  const { state } = useLocation();
  let { data } = state;
  console.log("useLocation :::", data);

  const { accessObject, showPage, setShowPage } = useAppContext();
  const { socket } = useAppContext();
  // const [searchPhoneNo, setSearchPhoneNo] = React.useState();
  // const [dataRows, setdataRows] = React.useState([]);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [loader, setLoader] = React.useState(false);
  const [changeStatus, setChangeStatus] = React.useState();
  const [filteredData, setFilteredData] = React.useState([]);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });
  const [alert, setAlert] = React.useState(null);
  const [rowValue, setRowValue] = React.useState();
  const [showBankDetails, setShowBankDetails] = React.useState([]);
  const [buttonLoader, setButtonLoader] = React.useState(false);
  const [filterEmail, setFilterEmail] = React.useState("");
  const [pageNumber, setPageNumber] = React.useState(1);
  const [recordLength, setRecordLength] = React.useState(10);
  const [totalLength, setTotalLength] = React.useState(0);
  const [buttonLoaderDecline, setButtonLoaderDecline] = React.useState(false);

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  React.useEffect(() => {
    getBranch();
  }, [filterEmail, pageNumber, recordLength, changeStatus]);

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const getBranch = () => {
    setLoader(true);
    axios
      .post(`${API_URL}/api/admin/history/get-history-payout-data`, {
        pageNumber: pageNumber,
        recordLength: recordLength,
        status: parseInt(changeStatus),
        search: filterEmail,
      })
      .then((response) => {
        setLoader(false);
        console.log("payout=============>", response.data.data);
        if (response?.data?.data?.totalLength.length > 0) {
          setFilteredData(response.data.data.getHistoryData);
          setTotalLength(response.data.data.totalLength[0].totalCount);
        } else {
          setFilteredData([]);
          setTotalLength(0);
        }
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };

  const handleApprove = (item) => {
    console.log("item...", item);
    setButtonLoader(true);
    const data = {
      historyId: item.historyId,
    };
    console.log("item::: ", data);
    axios(`${API_URL}/api/admin/history/withdraw-money-approve`, {
      method: "POST",
      credentials: "include",
      data: data,
    })
      .then((response) => {
        console.log("response::: ", response);
        getBranch();
        setChangeStatus(3);
        socket.emit("PlayerPayment");
        setButtonLoader(false);
        toast.success(response.data.message);
        setShowPage(false);
      })
      .catch((error) => {
        setChangeStatus(3);
        setButtonLoader(false);
        toast.success(error.message);
        console.log("getBranch error :::", error);
        setShowPage(false);
      });
  };

  const handleDecline = (item) => {
    const data = {
      historyId: item.historyId,
    };
    setButtonLoaderDecline(true);
    console.log("item::: ", data);
    axios(`${API_URL}/api/admin/history/withdraw-money-decline`, {
      method: "POST",
      credentials: "include",
      data: data,
    })
      .then((response) => {
        console.log("response::: ", response);
        getBranch();
        setChangeStatus(3);
        socket.emit("PlayerPayment");
        setShowPage(false);
        // alert(response.data.message);
        toast.success(response?.data?.message);
        setButtonLoaderDecline(false);
        setAlert(null);
      })
      .catch((error) => {
        // alert(error.message);
        setChangeStatus(3);
        toast.success(error?.message);
        console.log("getBranch error :::", error);
        setAlert(null);
      });
  };

  const clickEditButton = (item) => {
    console.log("item edit value :::", item);
    setShowBankDetails(item);
    setShowPage(true);
    setRowValue(item);
  };

  const warningWithConfirmMessage = (item) => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Decline"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          handleDecline(item);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to decline this reward request. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  return (
    <div>
      {alert}
      {showPage ? (
        <div class="content p-3 ">
          <div className="card p-3">
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  amount: rowValue ? rowValue?.amount : "",
                }}
                onSubmit={(values) => {
                  // handleApprove(rowValue);
                }}
              >
                {({ touched, errors, isSubmitting, values }) => (
                  <div>
                    <Form>
                      <div className="form-group">
                        <label htmlFor="password" className="mt-3">
                          Amount
                        </label>
                        <Field
                          disabled
                          type="text"
                          name="amount"
                          placeholder="Enter Amount"
                          className={`mt-2 form-control 
                          ${
                            touched.amount && errors.amount ? "is-invalid" : ""
                          }`}
                        />
                      </div>
                      <label htmlFor="password" className="mt-3">
                        Withdraw: {rowValue?.withdrawType}
                      </label>
                      {rowValue?.withdrawType === 1 && (
                        <table class="table table-bordered table-striped">
                          <tr>
                            {console.log("showBankDetails...", showBankDetails)}
                            <td style={{ fontWeight: 700 }}>Upi Id:</td>
                            <td>{rowValue?.upiId || "-"}</td>
                          </tr>
                        </table>
                      )}
                      {(rowValue?.withdrawType === 2 ||
                        rowValue?.withdrawType === 0) && (
                        <table class="table table-bordered table-striped">
                          <tr>
                            <td style={{ fontWeight: 700 }}>
                              Payment Country:
                            </td>
                            <td>{rowValue?.paymentCountry || "-"}</td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: 700 }}>Payment Contact</td>
                            <td>{rowValue?.paymentContact || "-"}</td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: 700 }}>
                              Payment User Name
                            </td>
                            <td>{rowValue?.paymentUserName || "-"}</td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: 700 }}>Paypal Email</td>
                            <td>{rowValue?.paypalEmail || "-"}</td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: 700 }}>
                              Paypal User Name
                            </td>
                            <td>{rowValue?.paypalUserName || "-"}</td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: 700 }}>Bank Unique No</td>
                            <td>{rowValue?.bankUniqueNo || "-"}</td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: 700 }}>
                              Bank Account Type
                            </td>
                            <td>{rowValue?.bankAccountType || "-"}</td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: 700 }}>Bank Account No</td>
                            <td>{rowValue?.bankAccountNo || "-"}</td>
                          </tr>
                        </table>
                      )}

                      <br />
                      <div className="d-flex">
                        <button
                          style={{ width: "100px" }}
                          type="submit"
                          className="btn btn-primary btn-block mt-4 mr-2"
                          disabled={buttonLoader}
                          onClick={() => handleApprove(rowValue)}
                        >
                          <div
                            className="d-flex"
                            style={{
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              className="d-flex"
                              style={{
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <b>Approve</b>
                            </div>
                            {buttonLoader && (
                              <div>
                                <div
                                  class="spinner-border ml-2 mt-1"
                                  role="status"
                                  style={{ height: "20px", width: "20px" }}
                                ></div>
                              </div>
                            )}
                          </div>
                        </button>
                        <button
                          style={{ width: "100px" }}
                          type="submit"
                          className="btn btn-danger btn-block mt-4 mr-2"
                          disabled={buttonLoaderDecline}
                          onClick={() => handleDecline(rowValue)}
                        >
                          <div
                            className="d-flex"
                            style={{
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              className="d-flex"
                              style={{
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <b>Decline</b>
                            </div>
                            {buttonLoaderDecline && (
                              <div>
                                <div
                                  class="spinner-border ml-2 mt-1"
                                  role="status"
                                  style={{ height: "20px", width: "20px" }}
                                ></div>
                              </div>
                            )}
                          </div>
                        </button>
                        <button
                          style={{ width: "100px" }}
                          type="submit"
                          className="btn btn-secondary btn-block mt-4 mr-2"
                          onClick={() => setShowPage(false)}
                        >
                          Cancel
                        </button>
                      </div>
                    </Form>
                  </div>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div class="card ">
            <div class="pl-4 pr-4 pt-4">
              <div className="row">
                <div className="col-md-3 col-lg-3">
                  <h3 class="card-title pb-2">
                    <b>Reward</b>
                  </h3>
                </div>
                <div className="col-md-3">
                  {accessObject?.payoutDownload == true && (
                    <div>
                      <button
                        className="btn btn-primary mr-2"
                        onClick={() => {
                          const input = document.getElementById("download-PDF");
                          const opt = {
                            filename: "History-List.pdf",
                          };
                          html2pdf().set(opt).from(input).save().from().toPdf();
                        }}
                      >
                        PDF
                      </button>
                      {/* <ReactHTMLTableToExcel
                        id="test-table-xls-button"
                        className="download-table-xls-button btn btn-warning"
                        table="table-to-xls"
                        filename="History"
                        sheet="History"
                        buttonText="Excel"
                      /> */}
                    </div>
                  )}
                </div>
                <div className="col-md-3 col-lg-3 d-flex justify-content-lg-end">
                  <div>
                    <div
                      className="form-group d-flex"
                      style={{ alignItems: "end" }}
                    >
                      <label>
                        <b className="">Status</b>
                      </label>
                      <select
                        className={`mx-2 form-control`}
                        onChange={(e) => {
                          setPageNumber(1);
                          setRecordLength(10);
                          setChangeStatus(e.target.value);
                        }}
                        value={changeStatus}
                      >
                        <option value={3}>All</option>
                        <option value={0}>Pending</option>
                        <option value={1}>Approve</option>
                        <option value={2}>Decline</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div>
                    <input
                      class="input-simple"
                      type="text"
                      value={filterEmail}
                      placeholder="Email"
                      style={{ width: "175px" }}
                      onChange={(e) => {
                        setPageNumber(1);
                        setRecordLength(10);
                        setFilterEmail(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              class="card-body"
              id="download-PDF"
              style={{ overflow: "scroll" }}
            >
              <table
                class="table table-bordered table-striped"
                id="table-to-xls"
              >
                <thead>
                  <tr>
                    <th style={{ textAlign: "center" }}>Id</th>
                    <th style={{ textAlign: "center" }}>Date</th>
                    <th style={{ textAlign: "center" }}>Player Id</th>
                    <th style={{ textAlign: "center" }}>Email</th>
                    <th style={{ textAlign: "center" }}>Amount</th>
                    <th style={{ textAlign: "center" }}>Status</th>
                    {parseInt(changeStatus) === 0 && (
                      <>
                        <th style={{ textAlign: "center" }}>Action</th>
                      </>
                    )}
                  </tr>
                </thead>

                {accessObject?.getPayoutList == true ? (
                  <>
                    <tbody>
                      {!loader ? (
                        <>
                          {filteredData.length > 0 ? (
                            <>
                              {filteredData?.map((item, index) => (
                                <>
                                  <tr
                                    key={index}
                                    style={{ textAlign: "center" }}
                                  >
                                    <td style={{ textAlign: "center" }}>
                                      {pageNumber === 1
                                        ? index + 1
                                        : index +
                                          1 +
                                          pageNumber * recordLength -
                                          recordLength}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {moment(item.createdAt).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.playerId ? item.playerId : "-"}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.email ? item.email : "-"}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {Math.round(item.amount * 100) / 100}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.status === 0
                                        ? "Pending"
                                        : item.status === 1
                                        ? "Success"
                                        : item.status === 2
                                        ? "Failed"
                                        : "-"}
                                    </td>
                                    {parseInt(changeStatus) === 0 && (
                                      <>
                                        <td style={{ textAlign: "center" }}>
                                          <EditIcon
                                            className="mr-3 courser"
                                            onClick={() =>
                                              clickEditButton(item)
                                            }
                                          />
                                          <ClearIcon
                                            className="courser text-danger"
                                            onClick={() =>
                                              warningWithConfirmMessage(item)
                                            }
                                          />
                                        </td>
                                      </>
                                    )}
                                  </tr>
                                </>
                              ))}
                            </>
                          ) : (
                            <EmptyState colSpan={7} />
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </tbody>
                  </>
                ) : (
                  <>
                    <tr style={{ backgroundColor: "rgba(0,0,0,.05)" }}>
                      <td colSpan={9}>
                        <h5 className="text-center">Access Denied</h5>
                      </td>
                    </tr>
                  </>
                )}
              </table>
              {accessObject?.getPayoutList == true && (
                <div className="mt-4">{loader && <Loader />}</div>
              )}
            </div>
            {accessObject?.getPayoutList == true &&
              filteredData.length != 0 && (
                <Pagination
                  updateShowPerpagevalue={updateShowPerpagevalue}
                  showPrePage={showPrePage}
                  onPaginationChange={onPaginationChange}
                  total={filteredData.length}
                  paginationTypeApi={true}
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                  recordLength={recordLength}
                  setRecordLength={setRecordLength}
                  totalLength={totalLength}
                />
              )}
          </div>
        </div>
      )}
    </div>
  );
}
